import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';

const baseUrl = process.env.REACT_APP_FMUK_BASE_API;

// Create an async thunk action
export const apiCall = createAsyncThunk(
  'api/apiCall',
  async (arg, { rejectWithValue }) => {
    try {
      // const response = await fetch('https://api.floodmapper.co.uk/documents/66875a4f-83ce-11ee-ac1e-0242ac140002');
      const response = await fetch(baseUrl + '/documents/66875a4f-83ce-11ee-ac1e-0242ac140002');
      if (!response.ok) {
        throw new Error('Server error!');
      }
      const data = await response.json();
      return data; // This will be the `fulfilled` action payload
    } catch (error) {
      return rejectWithValue(error.message); // This will be the `rejected` action payload
    }
  }
);


const apiSlice = createSlice({
  name: 'api',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    // Your synchronous reducers here
  },
  extraReducers: (builder) => {
    builder
      .addCase(apiCall.pending, (state) => {
        state.loading = true;
      })
      .addCase(apiCall.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(apiCall.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default apiSlice.reducer;